import { Component, Input } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup } from '@angular/forms';
import { BaseButtonSize, FormRawValue, BaseMinutesToHoursPipe } from 'base';
import {
  BaseDefaultCategoriesFormInterface,
  BaseInquiryCategoriesFormInterface,
} from '../../../_interfaces/base-inquiry-categories-form.interface';

@Component({
  selector: 'base-customer-publish-confirmation-modal',
  templateUrl: './base-customer-publish-confirmation-modal.component.html',
})
export class BaseCustomerPublishConfirmationModalComponent {
  @Input() modalRef: NgbModalRef;
  @Input() formValue: FormRawValue<FormGroup<BaseDefaultCategoriesFormInterface>>;

  buttonSize = BaseButtonSize;

  constructor(public minutesToHoursPipe: BaseMinutesToHoursPipe) {}

  getConfirmationMessage(category: FormRawValue<FormGroup<BaseInquiryCategoriesFormInterface>>): {
    key: string;
    params: any;
  } {
    const categoryName = category.name.toUpperCase();

    if (category.branches.length === 0) {
      return {
        key: 'selectDeselectServiceProvider.confirmationSettings.2',
        params: { category: categoryName },
      };
    }

    if (
      (category.deliveryTime === 0 && !this.formValue.sendToAllAtOnce) ||
      (this.formValue.sendToAllAtOnce && this.formValue.deliveryTimeImmediately)
    ) {
      return {
        key: 'selectDeselectServiceProvider.confirmationSettings.0',
        params: { sum: category.branches.length, category: categoryName },
      };
    }

    const dateTime = this.minutesToHoursPipe.transform(
      this.formValue.sendToAllAtOnce ? this.formValue.deliveryTimeToAll : category.deliveryTime,
      true
    );
    return {
      key: 'selectDeselectServiceProvider.confirmationSettings.1',
      params: {
        sum: category.branches.length,
        category: categoryName,
        dateTime,
      },
    };
  }

  publish() {
    this.modalRef.close();
  }
}
